import type { ProductApiData } from './types'

export interface FashionItemPayload {
  id?: number
  itemType: 'PRODUCT'
  productId: number | undefined
  quantity: number
  /** peças do item: é o campo que a elegibilidade da NF-e lê, não o `quantityPieces` do pedido */
  quantityPieces: number
  /** herdado do cadastro do produto; sem ele o item nasce inelegível para faturar */
  ncmId: number | null
  descount: number
  itemPrice: number
  sellingPrice: number | undefined
  kitIndex: number | undefined
  extraInfo: string
  nomeCustomizado: string | undefined
}

export const buildFashionItemsPayload = (items: ProductApiData[]): FashionItemPayload[] => {
  /** Mesmo par `productId`/`kitIndex` vira uma linha só: o backend guarda a grade por item. */
  const grouped = new Map<string, ProductApiData>()
  items.forEach((p) => {
    const id = p.fashionProduct?.id || p.fashionProductId
    if (id === undefined) return
    const kitKey = p.kitIndex !== null && p.kitIndex !== undefined ? String(p.kitIndex) : 'null'
    const key = `${id}-${kitKey}`
    if (grouped.has(key)) {
      const ex = grouped.get(key)!
      ex.items = [...ex.items, ...p.items]
      ex.totalItems += p.totalItems || 0
      ex.subtotal += p.subtotal || 0
    } else {
      grouped.set(key, { ...p })
    }
  })

  return Array.from(grouped.values()).map((p) => ({
    id: p.id,
    itemType: 'PRODUCT',
    productId: p.fashionProduct?.id || p.fashionProductId,
    quantity: p.totalItems ? Number(p.totalItems) : 0,
    quantityPieces: p.totalItems ? Number(p.totalItems) : 0,
    ncmId: p.fashionProduct?.ncmId ?? null,
    descount: p.discount ? Number(p.discount) : 0,
    itemPrice: p.subtotal ? Number(p.subtotal) : 0,
    sellingPrice: (p.sellingPrice !== undefined && p.sellingPrice !== null) ? Number(p.sellingPrice) : undefined,
    kitIndex: (p.kitIndex !== undefined && p.kitIndex !== null) ? p.kitIndex : undefined,
    nomeCustomizado: p.nomeCustomizado || undefined,
    extraInfo: JSON.stringify({
      fashionItems: p.items || [],
      colorCount: p.colorCount || 0,
      colors: p.colors || [],
      selectedColors: p.selectedColors || [],
      fashionProductName: p.fashionProduct?.name || p.name,
      fashionProductPrice: p.fashionProduct?.price || p.price,
      groupId: p.fashionProduct?.group?.id || p.group?.id,
      groupName: p.fashionProduct?.group?.name || p.group?.name,
      familyId: p.fashionProduct?.group?.family?.id || p.family?.id,
      familyName: p.fashionProduct?.group?.family?.name || p.family?.name,
      collectionId: p.fashionProduct?.group?.family?.collectionId,
    }),
  }))
}
